import * as React from "react";
import Typography from "@material-ui/core/Typography";
import type { UiBaseProps, UiElement } from "../uiProps.utils";

export enum TextVariant {
  H6 = "h6",
  SUBTITLE1 = "subtitle1",
  BODY1 = "body1",
  BODY2 = "body2",
  CAPTION = "caption",
}

export enum TextColor {
  SECONDARY = "textSecondary",
  ERROR = "error",
}

export type TextProps = UiBaseProps & {
  variant?: TextVariant;
  color?: TextColor;
  as?: UiElement;
  role?: string;
};

export const Text: React.FC<TextProps> = ({ variant = TextVariant.BODY1, as, ...rest }) => (
  <Typography variant={variant} {...(as ? { component: as } : {})} {...rest} />
);
